import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RoleAccessLayer from "../../components/RoleAccessLayer";
import AutorizacionesLayer from "../../components/comprobantes/AutorizacionesLayer"

const Autorizaciones = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Autorizaciones" />

        {/* RoleAccessLayer */}
        <AutorizacionesLayer/>

      </MasterLayout>

    </>
  );
};

export default Autorizaciones; 
